import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { EventDtoTypeEnum } from 'src/Services/API/generated';

interface EventFiltersState {
  selectedEventTypes: EventDtoTypeEnum[];
  showPracticalReminders: boolean;
  showRooms: boolean;
  setSelectedEventTypes: (types: EventDtoTypeEnum[]) => void;
  toggleEventType: (type: EventDtoTypeEnum) => void;
  setShowPracticalReminders: (value: boolean) => void;
  setShowRooms: (value: boolean) => void;
  clearFilters: () => void;
}

export const useEventFiltersStore = create<EventFiltersState>()(
  persist(
    set => ({
      selectedEventTypes: [],
      showPracticalReminders: false,
      showRooms: true,
      setSelectedEventTypes: types => set({ selectedEventTypes: types }),
      toggleEventType: type =>
        set(state => {
          if (state.selectedEventTypes.includes(type)) {
            return { selectedEventTypes: state.selectedEventTypes.filter(t => t !== type) };
          } else {
            return { selectedEventTypes: [...state.selectedEventTypes, type] };
          }
        }),
      setShowPracticalReminders: value => set({ showPracticalReminders: value }),
      setShowRooms: value => set({ showRooms: value }),
      clearFilters: () =>
        set({ selectedEventTypes: [], showPracticalReminders: false, showRooms: true }),
    }),
    {
      name: 'calendar-filters-storage',
    }
  )
);
